import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/** The one card style: white, thin border, 14px corners. Optional title row with actions. */
const SectionCard = ({ title, subtitle, actions, children, sx, contentSx }) => (
  <Paper variant="outlined" sx={{ p: { xs: 2, md: 3 }, mb: 3, ...sx }}>
    {(title || actions) && (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 2 }}>
        <Box sx={{ minWidth: 0 }}>
          {title && (
            <Typography variant="h6" component="h2">
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
      </Box>
    )}
    <Box sx={contentSx}>{children}</Box>
  </Paper>
);

export default SectionCard;
